import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity';
import { AgentData } from './supportScript';
import agentPopup from '@/themes/themeOne/agent/agentPopup.vue';
import agentPopupTwo from '@/themes/themeTwo/agent/agentPopup.vue';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'agentPopup',
  emits: ['handleCloseagent', 'openPromotion'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const show = ref(false)
const activityStore = useActivityStore()
const bannerImage = ref('')
const active = ref(0)
const activeTab = ref(0)
const emits = __emit
const themeStore = useThemeStore()

const dataSet = computed<AgentData>(() => ({
    show:show.value,
    bannerImage:bannerImage.value,
    activeTab:activeTab.value,
}))
const open = () => {
    show.value = true
    let activityList = computed(() => activityStore.activityList)
    let agentConfig = activityList.value.find(
        (item:any) => item.name === 'agent_cash_back'
    ) || null;
    bannerImage.value = agentConfig?.floatIcon
}
const close = () => {
    activeTab.value = 0
    active.value = 0
    show.value = false
    emits('handleCloseagent')
    if(localStorage.getItem('agentOpenFromPromotion') == 'true'){
        localStorage.setItem('footerPopupOpen', '3')
        localStorage.setItem('openPromotionPopup', 'true')
        emits('openPromotion')
        localStorage.setItem('agentOpenFromPromotion', 'false')
    }
    
}
const onClickTab = (value: any) => {
    activeTab.value = value.name
}

__expose({
    open,
    close
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(agentPopup, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onClose: close,
            show: show.value,
            "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event))
          }, null, 8, ["data-set", "show"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(agentPopupTwo, {
            "data-set": dataSet.value,
            onOnClickTab: onClickTab,
            onClose: close,
            show: show.value,
            "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event))
          }, null, 8, ["data-set", "show"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})